export default __webpack_public_path__ + "static/media/megaphone_icon.cc4df9c4.svg";